import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import type { FoodModeItem } from 'app/filters/_static/foodModes'

import { filterActions, useFilterOptions, useFilter } from '../../filterStore'

import { emptyArray } from './helpers'

export const FoodModeControl = () => {
  const ids = useFilter('foodModeIds')
  const foodModes = useFilterOptions('foodModes')

  return (
    <PlainItemsSelector
      id="foodMode"
      label="Режим питания"
      header="Выбор режима питания"
      items={foodModes}
      selection={ids.draft || emptyArray}
      defaultSelection={ids.default || emptyArray}
      onChange={(selected) =>
        filterActions.selectDraftFoodModeIds(selected as Array<FoodModeItem['id']> | undefined)
      }
      skipUpperSpace
      multiple
    />
  )
}
